// Dashboard Stat card

interface StatCardProps {
    icon: React.ElementType
    label: string
    value: number | string
    sub?: string
    colour: string
    loading?: boolean
    onClick?: () => void
    disabled?: boolean
}

export const StatCard = ({ icon: Icon, label, value, sub, colour, loading, onClick, disabled }: StatCardProps) => {
    const isClickable = !!onClick && !disabled
    return (
        <div
            className={`bg-card rounded-xl border border-border p-5 flex items-start gap-4 shadow-sm
                ${isClickable ? 'cursor-pointer hover:border-border/80 transition-colors' : ''}
                ${disabled ? 'opacity-40 cursor-not-allowed' : ''}`}
            onClick={isClickable ? onClick : undefined}
        >
            <div className={`h-11 w-11 rounded-xl flex items-center justify-center shrink-0 ${colour}`}>
                <Icon className="h-5 w-5 text-white" />
            </div>
            <div className="min-w-0">
                <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide">{label}</p>
                {loading ? (
                    <div className="mt-1 h-7 w-12 bg-muted rounded animate-pulse" />
                ) : (
                    <p className="text-2xl font-bold text-foreground mt-0.5">{value}</p>
                )}
                {sub && !loading && (
                    <p className="text-xs text-muted-foreground mt-0.5">{sub}</p>
                )}
            </div>
        </div>
    )
}

